var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgFacebookLogoTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220.51 383.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#00857c;stroke-miterlimit:10;stroke-width:15px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.01,73.41l35.71,.93V9.36l-52.91-1.86c-49.73,0-90.04,40.31-90.04,90.04v57.55H7.5v69.62h61.27v151.32h77.05V224.71h54.77l11.14-69.62h-65.91v-51.49c0-16.68,13.52-30.2,30.2-30.2Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogoTeal);
export default __webpack_public_path__ + "static/media/facebook-logo-teal.2affc85009370048754fc29618be769b.svg";
export { ForwardRef as ReactComponent };